import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { appRoutes } from '../../../path';
import ProtectedRoute from '../../../components/ProtectedRoute';
import { PermissionKey } from '../../../utils/apollo/graphqlSchema';
import Users from './Users';
import AllUsers from './AllUsers';
import PendingUsers from './PendingUsers';
import UserModify from './UserModify';
import UserOverviewContainer from './UserOverview/UserOverviewContainer';

export const userRoutes: RouteObject[] = [
  {
    path: appRoutes.permission.users,
    element: <Navigate replace={true} to={appRoutes.permission.allUsers} />,
  },
  {
    path: appRoutes.permission.users,
    element: <Users />,
    children: [
      {
        path: appRoutes.permission.allUsers,
        element: <AllUsers />,
      },
      {
        path: appRoutes.permission.pendingUsers,
        element: <PendingUsers />,
      },
    ],
  },
  {
    path: appRoutes.permission.users + '/:userId',
    element: <UserOverviewContainer />,
  },
  {
    path: appRoutes.permission.users + '/:userId/edit',
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.AdminEdit]}>
        <UserModify />
      </ProtectedRoute>
    ),
  },
];

// Keep the component for backwards compatibility
export default function UsersRoutes() {
  return userRoutes;
}
